const extractClassNamesFromVNode = (vNode) => {
    var _a;
    const vNodeClass = (_a = vNode === null || vNode === void 0 ? void 0 : vNode.data) === null || _a === void 0 ? void 0 : _a.class;
    if (Array.isArray(vNodeClass))
        return vNodeClass;
    if (typeof vNodeClass === 'string')
        return vNodeClass.split(' ');
    return [];
};

export { extractClassNamesFromVNode };
